import React from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Text from "component/typography/Text";
import Icon from "component/typography/Icon";

import { sizes, colors } from "asset/constant";
import { css } from "style";
import { mq, sn } from "utils";
import { _goToOrderDetails } from "router/helper";
import Separator from "component/section/Separator";

const FactorItemRow = (props: {
  title?: string;
  attrs?: string;
  etc: boolean;
  attrs_arr?: Array<string>;
}) => {
  const { title, attrs_arr, etc } = props;

  if (!etc && !title) {
    return <></>;
  }

  return (
    <View style={{ ...css.rRowCenterAlign }}>
      <View
        style={{
          top: mq(1),
          width: mq(8),
          height: mq(5),
          marginLeft: mq(5),
          borderRadius: mq(8),
          backgroundColor: colors.theme + "aa",
        }}
      />
      {title ? (
        <>
          <Text weight="bold">{title}</Text>
          {/* {attrs && <Text size={"sm"}> ({attrs})</Text>} */}
          <View
            style={{
              flexDirection: "row-reverse",
              marginHorizontal: 6,
            }}
          >
            {attrs_arr?.map((attr: string, key: number) => {
              return (
                <Text key={String(key)}>
                  {key !== 0 && attrs_arr?.length > 1 && " - "}
                  {attr}
                </Text>
              );
            })}
          </View>
        </>
      ) : (
        <Text style={{ bottom: mq(2) }}>...</Text>
      )}
    </View>
  );
};

export default function OrderCard(props: { order: FactorT }) {
  const { order } = props;

  const _goToFactor = () => _goToOrderDetails(order.id, order.company_name);

  return (
    <TouchableOpacity
      onPress={_goToFactor}
      style={styles.container}
      activeOpacity={sizes.tapOpacity}
    >
      <>
        {[5, -8, 12].map((num, key) => {
          return (
            <View
              key={String(key)}
              style={[
                css.fix,
                css.circle(220),
                { right: mq(15 * num), top: mq(-8 * num) },
                css.border(2, colors.theme + "07"),
              ]}
            />
          );
        })}
      </>
      <View style={css.rRow}>
        <View style={{ ...css.container, top: mq(-5) }}>
          <View style={css.rRowCenterAlign}>
            <Text weight="extraBold" size={"xl"}>
              {order.company_name}{" "}
              <Text size={"sm"} weight="bold">
                (شماره {order.id})
              </Text>
            </Text>
          </View>
          <View style={{ ...css.rRowCenterAlign, marginTop: mq(5) }}>
            <Icon name="calendar" size={mq(14)} />
            <Text weight="bold"> {order.created_at} </Text>
          </View>
          <View style={{ ...css.rRowCenterAlign }}>
            <View
              style={{
                ...css.circle(8),
                top: mq(1),
                backgroundColor: order?.status?.color,
              }}
            />
            <Text weight="bold" size={"xs"} color={order?.status?.color}>
              {" "}
              {order?.status?.title}
            </Text>
          </View>
        </View>
        <View>
          <Icon name="leftcircle" size={mq(25)} />
        </View>
      </View>
      <View
        style={{
          top: mq(-5),
          paddingHorizontal: mq(5),
          borderRadius: sizes.radius.md,
          borderColor: colors.border.lightest,
        }}
      >
        <View>
          <Separator
            color={colors.border.lightest + "77"}
            sidesSpace={mq(10)}
          />
          <View style={{ height: sn("auto", "auto", 50, 50) }}>
            {[...order?.items?.slice(0, 2), undefined]?.map(
              (item: FactorItemsDataT | undefined, key: number) => {
                return (
                  <React.Fragment key={String(key)}>
                    <FactorItemRow
                      title={item?.product_name}
                      attrs={""}
                      etc={order?.items?.length > 2}
                      attrs_arr={item?.new_attributes}
                    />
                  </React.Fragment>
                );
              }
            )}
          </View>
        </View>
      </View>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  container: {
    borderRadius: sizes.radius.lg,
    backgroundColor: colors.bg.element,
    borderWidth: 1,
    borderColor: colors.border.light,
    padding: mq(10),
    overflow: "hidden",
    width: "94%",
    alignSelf: "center",
  },
});
